import { Component, h, Prop } from '@stencil/core';

@Component({
  tag: 'biel-search-result',
  styleUrl: 'biel-search-result.css',
  shadow: true,
})
export class BielSearchResult {

  @Prop() resultTitle: string;
  @Prop() resultFragment: string;
  @Prop() resultUrl: string;
  @Prop() searchQuery: string;
  @Prop() isSelected: boolean;

  cleanMarkdown(text: string): string {
    if (!text) return '';
  
    return text
      // Remove bold/italic (complete and truncated, e.g., **text, *text).
      .replace(/(\*\*|__)(.*?)(\*\*|__)?/g, '$2') // Bold
      .replace(/(\*|_)(.*?)(\*|_)?/g, '$2') // Italic
      // Remove inline code (complete and truncated, e.g., `code or `code`).
      .replace(/`([^`]*)`?/g, '$1')
      // Remove links (e.g., [text](url) and truncated forms like [text...).
      .replace(/\[([^\]]+)\]\(([^)]+)?\)/g, '$1') // Complete links
      .replace(/\[([^\]]+)\]?\(?/g, '$1') // Truncated links
      // Remove headers (e.g., ## Header) and incomplete/truncated headers.
      .replace(/^#{1,6}\s+(.*)/gm, '$1')
      // Remove blockquotes (e.g., > text).
      .replace(/^>\s+/gm, '')
      // Remove horizontal rules (e.g., --- or ***).
      .replace(/^-{3,}$/gm, '')
      .replace(/^\*{3,}$/gm, '')
      // Remove code blocks (e.g., ```code block``` and truncated blocks).
      .replace(/```[\s\S]*?```|```[\s\S]*$/g, '') // Backtick blocks
      .replace(/~~~[\s\S]*?~~~|~~~[\s\S]*$/g, '') // Tilde blocks
      // Remove Markdown tables and pipe characters.
      .replace(/^\|.*?\|$/gm, '') // Complete table rows
      .replace(/(\|---+)+\|?/g, '') // Table dividers and truncated rows
      // Remove consecutive backslashes or hyphens.
      .replace(/\\+/g, '') // Remove all backslashes
      .replace(/-{2,}/g, '') // Remove consecutive hyphens
      .replace(/\|\s*\|(\s*\|)+/g, '') // Remove consecutive pipes
      // Trim excessive whitespace or empty lines.
      .replace(/^\s+|\s+$/g, '') // Trim surrounding whitespace
      .replace(/\n{2,}/g, '\n') // Collapse multiple newlines
      .trim();
  }  
  
  highlightMatch(text: string) {
    if (!this.searchQuery) return text;

    const regex = new RegExp(`(${this.searchQuery})`, 'gi');
    const parts = text.split(regex);

    return parts.map((part) =>
      part.toLowerCase() === this.searchQuery.toLowerCase() ? (
        <mark class="biel-search-result__mark">{part}</mark>
      ) : (
        part
      )
    );
  }

  render() {
    const cleanedTitle = this.cleanMarkdown(this.resultTitle);
    const cleanedFragment = this.cleanMarkdown(this.resultFragment) || "...";

    return (
      <a class="biel-search-result" href={this.resultUrl} onClick={(event) => {event.preventDefault();}}>
        <div class={`biel-search-result-container ${this.isSelected ? "selected" : ""}`}>
          <span class="biel-search-result__title">{this.highlightMatch(cleanedTitle)}</span>
          <span class="biel-search-result__description">{this.highlightMatch(cleanedFragment)}</span>
        </div>
      </a>
    );
  }
}
